import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHeatExchangerFinnedTubes = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 100,
	height: 30,
	viewBox: "0 0 100.0 30.0",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 0,
		y: 0,
		width: 100,
		height: 30,
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	}), /* @__PURE__ */ _jsx("path", {
		d: "M 15.0 0.0 L 15.0 30.0 M 85.0 0.0 L 85.0 30.0 M 26.0 10.0 L 26.0 20.0 M 42.0 10.0 L 42.0 20.0 M 58.0 10.0 L 58.0 20.0 M 74.0 10.0 L 74.0 20.0 M 66.0 10.0 L 66.0 20.0 M 50.0 10.0 L 50.0 20.0 M 34.0 10.0 L 34.0 20.0 M 15.12 15.0 L 85.0 15.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})]
});
export default SvgHeatExchangerFinnedTubes;
